import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { HttpClient } from '@angular/common/http';
import { AirModel } from 'src/app/models/air/air-model';
import {Observable} from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MinDTO } from 'src/app/models/min-dto';
import { DashboardListResultCount } from 'src/app/models/air/list/dashboard-list-result-counts';
import { MarketAirProductsModel } from 'src/app/models/air/market-air-products.model';
import { SseService } from '../sse-service';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root'
})
export class AirSearchService  extends BaseService<any>{

  constructor(public httpClient: HttpClient, public sseService: SseService) {
      super(
          'air',
          httpClient);
  }
  
  search(airModel: AirModel): Observable<AirModel> {
    let uri = new URL(environment.baseUrl + `/air/search`);

     const uuid = uuidv4();
      localStorage.setItem("requestId", uuid);
      if(localStorage.getItem("requestId")) {
        this.sseService.connect(uuid);
      }

    const payload = { ...airModel };
    payload.onlinePriceUuid= uuid;

    if (payload.readinessDate) {
      const d = new Date(payload.readinessDate);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      
      (payload as any).readinessDate = `${year}-${month}-${day}`;
    }
    
    
    return this.httpClient.post<AirModel>(uri.toString(), payload, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      map((data: AirModel) => {

        if (data.readinessDate) {
            data.readinessDate = new Date(data.readinessDate);
        }

        // Gelen data (AirModel) içindeki products listesini kontrol et
        if (data && data.products) {
          data.products = data.products.sort((a, b) => {
            
            // 1. Havayolu (airline) bilgisine göre sıralama
            if (a.airline === null && b.airline !== null) return 1;
            if (a.airline !== null && b.airline === null) return -1;
            if (a.airline !== null && b.airline !== null) {
              if (a.airline < b.airline) return -1;
              if (a.airline > b.airline) return 1;
            }
          
            // 2. Havayolu aynı veya null ise grandTotal'a göre sıralama
            const grandTotalA = a.freights && a.freights.grandTotal !== null ? a.freights.grandTotal : Infinity;
            const grandTotalB = b.freights && b.freights.grandTotal !== null ? b.freights.grandTotal : Infinity;
          
            return grandTotalA - grandTotalB;
          });
        }
        // Modifiye edilmiş objeyi geri döndür (Observable içinde yayınlanacaktır)
        return data;
      }),
      catchError(this.handleError)
    )
  }
  
  discount(segmentId: number): Observable<string[]> {
    let uri = new URL(environment.baseUrl + `/air/discount/${segmentId}`);
    return this.httpClient.get<string[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

  get(marketOfferRequestsId: number): Observable<AirModel> {
    let uri = new URL(environment.baseUrl + `/air`).updateQueryParam({ id: marketOfferRequestsId });
    
    return this.httpClient.get<AirModel>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

  segment(fromAirportId: number, toAirportId: number): Observable<MinDTO> {
    let uri = new URL(environment.baseUrl + `/air/segment`).updateQueryParam({ fromAirportId, toAirportId });
    
    return this.httpClient.get<MinDTO>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }
  
  offer(airModel): Observable<AirModel> {
    let uri = new URL(environment.baseUrl + `/air/offer`);
    
    return this.httpClient.post<AirModel>(uri.toString(), airModel, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

    
  due(product: MarketAirProductsModel, due: number, ref: string, id: number, cwg: number, grossWeight: number, volume: number): Observable<MarketAirProductsModel> {
    let uri = new URL(environment.baseUrl + `/air/due`).updateQueryParam({ due, ref, id, cwg, grossWeight, volume});
    
    return this.httpClient.post<MarketAirProductsModel>(uri.toString(), product, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }

  shipment(airModel): Observable<AirModel> {
    let uri = new URL(environment.baseUrl + `/air/shipment`);
    
    return this.httpClient.post<AirModel>(uri.toString(), airModel, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }
  insurance(airModel): Observable<AirModel> {
    let uri = new URL(environment.baseUrl + `/air/insurance`);
    
    return this.httpClient.post<AirModel>(uri.toString(), airModel, { withCredentials: false, headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }
    searchHistory(): Observable<AirModel[]> {
      let uri = new URL(environment.baseUrl + `/air/searchHistory`);
      return this.httpClient.get<AirModel[]>(uri.toString(), { withCredentials: false, headers: this.httpHeaders() })
      .pipe(
        tap(),
        catchError(this.handleError)
      )
    }

    getAiHint(body: any): Observable<any> {
    let uri = new URL(`${environment.baseUrl}/public/aihint/air`)

    return this.httpClient.post<any>(uri.toString(), body, { withCredentials: false,  headers: this.httpHeaders() })
    .pipe(
      tap(),
      catchError(this.handleError)
    )
  }


}